'use client';

import { Flex } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';
import { MdOutlineLocationOn } from 'react-icons/md';

import { categories } from '@/modules/shared/presentation/constants';
import { useJobLocationsSelectorState } from '@/modules/shared/presentation/hooks/useJobLocationsSelectorState';

import { CategorySelectDialog } from '../CategorySelectorDialog/CategorySelectorDialog';

type SelectorDialogProps = PropsWithChildren<{
	count?: number
}>;

export const JobLocationsSelectorDialog = ({ children, count = 0 }: SelectorDialogProps) => {
	const {
		collections,
		handleToggle,
		isLoading,
		selectedIds,
		setGroup,
	} = useJobLocationsSelectorState();

	return (
		<CategorySelectDialog.Root>
			<CategorySelectDialog.Trigger asChild>
				{children}
			</CategorySelectDialog.Trigger>
			<CategorySelectDialog.Content>
				<CategorySelectDialog.CloseIcon />
				<CategorySelectDialog.Header icon={MdOutlineLocationOn} title="Job Location" />
				<CategorySelectDialog.Body as={Flex} direction="row">
					<CategorySelectDialog.SideBar
						groups={categories}
						onSelectGroup={setGroup}
					/>
					<CategorySelectDialog.Checklist
						collections={collections}
						isLoading={isLoading}
						onSelect={handleToggle}
						selectedIds={selectedIds}
					/>
				</CategorySelectDialog.Body>
				<CategorySelectDialog.Footer>
					<CategorySelectDialog.ActionButton count={count} label="Select" />
				</CategorySelectDialog.Footer>
			</CategorySelectDialog.Content>
		</CategorySelectDialog.Root>
	);
};
